<template>
  <div class="edit-card" style="margin-top:10px;padding-bottom:10px">
    <div style="width:88%;display: flex">
      <div class="start-label" />
      <span class="text">{{ title }}</span>
    </div>

    <el-form label-position="top" ref="form" :model="form" :rules="rulesT">
      <el-row>
        <el-col :span="6">
          <el-form-item :label="resultName" prop="result">
            <el-select v-model="form.result" placeholder="请选择状态" style="width:90%" @change="(val)=>change(val,'result')">
              <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :span="6">
              <el-form-item class="isReturnSupplierBox"  v-if="$route.name == 'ApplyInStockEdit'" >
                <el-checkbox v-model="form.isReturnSupplier" @change="changeIsReturnSupplier">是否自动退货给供应商</el-checkbox>
              </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="reasonSpanVal">
          <el-form-item :label="reasonName" prop="reason">
            <el-input v-model="form.reason" :placeholder="'请填写' + reasonName" type="textarea" resize="none" :rows="5" style="width:95%" @change="(val)=>change(val,'reason')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { WhetherOptions } from "@/enum";

export default {
  data () {
    return {
      WhetherOptions: WhetherOptions,
      form: {
        result: 1,
        reason: "",
      },
      rulesT: {
        reason: [
          { required: true, validator: this.validateReason, trigger: "blur" },
        ],
      },
    };
  },
  props: {
    title: {
      type: String,
      default () {
        return "审核信息";
      },
    },
    resultName: {
      type: String,
      default () {
        return "审核合格";
      },
    },
    reasonName: {
      type: String,
      default () {
        return "审核情况";
      },
    },
    rules: {
      type: Object,
      default () {
        return this.rulesT;
      },
    },
    reasonSpanVal: {
      type: Number,
      default () {
        return 12
      }
    }
  },
  methods: {
    change (val,type) {
      this.$emit("change", this.form.result, this.form.reason, this.form.isReturnSupplier,type);
    },
    changeIsReturnSupplier(val){
       this.$emit("change",this.form.result, this.form.reason, this.form.isReturnSupplier,'isReturnSupplier');
    },
    validateReason (rule, value, callback) {
      if (this.form.result == 0 && (!value || value == "")) {
        callback(new Error(`请填写${this.reasonName}`));
      } else {
        callback();
      }
    },
  },
  watch: {
    rules (val, oldVal) {
      this.rulesT = val;
    },
  },
  created () {
    this.change();
  },
};
</script>

<style>
.isReturnSupplierBox {
  margin-top: 30px;
}
</style>